import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import CubeWrapper from '@/mobile/src/components/appV4/CubeWrapper.vue'
import CXScorecard from '@/mobile/src/widgets/CXScorecard.vue'
import GoalTracking from '@/mobile/src/components/appV4/GoalTracking.vue'

interface Props {
    showGoalTracking: boolean
}

export default /*#__PURE__*/_defineComponent({
  __name: 'HomeCube',
  props: {
    showGoalTracking: { type: Boolean, default: false }
  },
  emits: ['set-show-report-card', 'toggle-show-goal-tracking'],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CubeWrapper, {
    face: !_ctx.showGoalTracking ? 'front' : 'right',
    class: "huddle-cube"
  }, {
    front: _withCtx(() => [
      _createVNode(CXScorecard, {
        class: "cube__face cube__face--front",
        "load-report-card": () => _ctx.$emit('set-show-report-card', true),
        onGoalClicked: _cache[0] || (_cache[0] = () => _ctx.$emit('toggle-show-goal-tracking', true))
      }, null, 8, ["load-report-card"])
    ]),
    right: _withCtx(() => [
      _createVNode(GoalTracking, {
        class: "cube__face cube__face--right",
        "on-back": () => _ctx.$emit('toggle-show-goal-tracking', false)
      }, null, 8, ["on-back"])
    ]),
    _: 1
  }, 8, ["face"]))
}
}

})